import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const MySpaceLayout = () => {
  return (
    <div className="mt-8">
      <div className="flex gap-6 mb-6">
        <NavLink to="" end className={({isActive}) => isActive ? 'bg-indigo-600 text-white rounded-t-md px-6 py-2 font-medium' : 'bg-slate-100 text-slate-800 rounded-t-md px-6 py-2 font-medium hover:bg-indigo-100'}>Profile</NavLink>
        <NavLink to="overview" className={({isActive}) => isActive ? 'bg-indigo-600 text-white rounded-t-md px-6 py-2 font-medium' : 'bg-slate-100 text-slate-800 rounded-t-md px-6 py-2 font-medium hover:bg-indigo-100'}>Overview</NavLink>
        <NavLink to="dashboard" className={({isActive}) => isActive ? 'bg-indigo-600 text-white rounded-t-md px-6 py-2 font-medium' : 'bg-slate-100 text-slate-800 rounded-t-md px-6 py-2 font-medium hover:bg-indigo-100'}>Dashboard</NavLink>
      </div>
      <div className="bg-white rounded-b-lg shadow p-8">
        <Outlet />
      </div>
    </div>
  );
};

export default MySpaceLayout;
